/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const LanguageDirection = Object.freeze({
  RTL: 'rtl',
  LTR: 'ltr',
});
